<template>
    <v-container fluid>
        <modal-detalle :objModaldetalle="objModaldetalle"></modal-detalle>
        <modal-impresion :objModalImpresion="objModalImpresion"></modal-impresion>

        <modal-detalle-pago :objModalDetallePago="objModalDetallePago"></modal-detalle-pago>
        <modal-estado-pago :objModalEstadoPago="objModalEstadoPago"></modal-estado-pago>
        <modal-estado-venta :objModalEstadoVenta="objModalEstadoVenta"></modal-estado-venta>
        <modal-direccion :objModalDireccion="objModalDireccion"></modal-direccion>
        <modal-emitir-sunat :objModalEmitirSunat="objModalEmitirSunat"></modal-emitir-sunat>
        <modal-anular-sunat :objModalAnularSunat="objModalAnularSunat"></modal-anular-sunat>
        <modal-editar-emitir-sunat :objModalEditarEmitirSunat="objModalEditarEmitirSunat"></modal-editar-emitir-sunat>
        <modal-emitir-sunat-masivo :objModalEmitirSunatMasivo="objModalEmitirSunatMasivo"></modal-emitir-sunat-masivo>
        <v-row>
            <v-col cols="12">
                <v-card class="" elevation="" max-width="">
                    <v-card-title class="justify-center">GESTIONAR VENTAS</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row>
                            <div class="col-12">
                                <p>
                                    <router-link exact="" style="text-decoration: none" :to="{ name: 'inicioPanel' }">
                                        Inicio
                                    </router-link>
                                    /
                                    <router-link exact="" style="text-decoration: none" :to="{ name: 'ventasPanel' }">
                                        Ventas
                                    </router-link>
                                </p>
                            </div>

                            <v-col cols="12">
                                <v-btn
                                    small
                                    title="Limpiar filtros"
                                    fab
                                    dark
                                    color="blue-grey"
                                    depressed
                                    @click="limpiarFiltros()"
                                >
                                    <v-icon dark>mdi-refresh</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col xl="2" lg="2" md="2" sm="12" cols="12">
                                <v-select
                                    v-model="cmbCantidadRegistros"
                                    item-text="texto"
                                    item-value="valor"
                                    :items="arrCantidadRegistros"
                                    label="Cantidad de registros"
                                    @change="listarRegistros()"
                                    dense
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col cols="12" xl="2" lg="2" md="2" sm="12">
                                <v-menu :close-on-content-click="false" max-width="290">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            outlined
                                            :value="formatFecha(filtroFechaDesde)"
                                            dense
                                            clearable
                                            label="Desde"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            @click:clear="
                                                paginaActual = 1;
                                                filtroFechaDesde = '';
                                                listarRegistros();
                                            "
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="filtroFechaDesde" locale="es-es"></v-date-picker>
                                </v-menu>
                            </v-col>

                            <v-col cols="12" xl="2" lg="2" md="2" sm="12">
                                <v-menu :close-on-content-click="false" max-width="290">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            outlined
                                            :value="formatFecha(filtroFechaHasta)"
                                            dense
                                            clearable
                                            label="Hasta"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            @click:clear="
                                                paginaActual = 1;
                                                filtroFechaHasta = '';
                                                listarRegistros();
                                            "
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="filtroFechaHasta" locale="es-es"></v-date-picker>
                                </v-menu>
                            </v-col>

                            <v-col xl="3" lg="3" md="3" sm="12" cols="12">
                                <v-select
                                    clearable
                                    v-model="filtroEstadoPago"
                                    item-text="nombre"
                                    item-value="idestado_pago"
                                    :items="cmbEstadoPago"
                                    label="Estado Pago"
                                    @change="
                                        paginaActual = 1;
                                        listarRegistros();
                                    "
                                    dense
                                    outlined
                                ></v-select>
                            </v-col>

                            <v-col xl="3" lg="3" md="3" sm="12" cols="12">
                                <v-select
                                    clearable
                                    v-model="filtroMetodoPago"
                                    item-text="descripcion"
                                    item-value="idmetodo_pago"
                                    :items="cmbMetodoPago"
                                    label="Metodo Pago"
                                    @change="
                                        paginaActual = 1;
                                        listarRegistros();
                                    "
                                    dense
                                    outlined
                                ></v-select>
                            </v-col>

                            <v-col cols="12" class="text-left">
                                <v-btn class="my-0" color="info" elevation="" @click="filtrar()">
                                    <v-icon>mdi-filter</v-icon>
                                    Filtrar
                                </v-btn>
                            </v-col>

                            <v-col cols="12">
                                <v-btn :loading="btnReporteExcel" fab elevation="" @click="reporteExcel()">
                                    <v-icon large color="success">mdi-file-excel</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="12" v-show="selected.length > 0">
                                <v-alert dense text type="info" class="mb-0 d-flex align-center flex-wrap">
                                    <span class="mr-4">{{ selected.length }} seleccionadas</span>
                                    <v-btn small color="info" class="mr-2 my-1" @click="imprimirSeleccionados()">
                                        <v-icon left small>mdi-printer</v-icon>
                                        Imprimir seleccionadas
                                    </v-btn>
                                    <v-btn
                                        small
                                        color="success"
                                        class="mr-2 my-1"
                                        v-show="validarPermiso('ventas.enviarSunat')"
                                        @click="enviarSunatSeleccionados()"
                                    >
                                        <v-icon left small>mdi-send</v-icon>
                                        Enviar a SUNAT
                                    </v-btn>
                                    <v-btn small text class="my-1" @click="selected = []">
                                        Limpiar selección
                                    </v-btn>
                                </v-alert>
                            </v-col>

                            <v-col cols="12" v-show="arrRegistrosTabla.length > 0">
                                <v-data-table
                                    ref="tblListado"
                                    v-model="selected"
                                    :headers="headers"
                                    :items="arrRegistrosTabla"
                                    item-key="idventa"
                                    :item-class="rowClass"
                                    show-select
                                    fixed-header
                                    height="65vh"
                                    disable-sort
                                    disable-pagination
                                    hide-default-footer
                                    class="text-no-wrap"
                                >
                                    <template v-slot:item.gestionar="{ item }">
                                        <v-menu offset-y>
                                            <template v-slot:activator="{ on: onMenu, attrs: attrsMenu }">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on: onTip, attrs: attrsTip }">
                                                        <v-btn
                                                            small
                                                            dark
                                                            depressed
                                                            icon
                                                            color="cyan"
                                                            v-bind="{ ...attrsMenu, ...attrsTip }"
                                                            v-on="{ ...onMenu, ...onTip }"
                                                        >
                                                            <v-icon>mdi-cursor-default-click</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Gestionar</span>
                                                </v-tooltip>
                                            </template>
                                            <v-list>
                                                <v-list-item
                                                    v-show="validarPermiso('ventas.editar')"
                                                    @click="
                                                        objModalEstadoVenta = {
                                                            idventa: item.idventa,
                                                            idestado_control_de_venta:
                                                                estadoControlDeVenta.ENTRANTE,
                                                            titulo: 'Entrante',
                                                            openModal: true,
                                                        }
                                                    "
                                                >
                                                    <v-list-item-title>
                                                        <v-icon>mdi-autorenew</v-icon>
                                                        Ventas Entrantes
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item
                                                    v-show="validarPermiso('ventas.editar')"
                                                    @click="
                                                        objModalEstadoVenta = {
                                                            idventa: item.idventa,
                                                            idestado_control_de_venta:
                                                                estadoControlDeVenta.POR_ENVIAR,
                                                            titulo: 'Por Enviar',
                                                            openModal: true,
                                                        }
                                                    "
                                                >
                                                    <v-list-item-title>
                                                        <v-icon>mdi-autorenew</v-icon>
                                                        Ventas Por Enviar
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item
                                                    v-show="validarPermiso('ventas.editar')"
                                                    @click="
                                                        objModalEstadoVenta = {
                                                            idventa: item.idventa,
                                                            idestado_control_de_venta:
                                                                estadoControlDeVenta.FINALIZADA,
                                                            titulo: 'Finalizadas',
                                                            openModal: true,
                                                        }
                                                    "
                                                >
                                                    <v-list-item-title>
                                                        <v-icon>mdi-autorenew</v-icon>
                                                        Ventas Finalizadas
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item
                                                    v-show="validarPermiso('ventas.editar')"
                                                    @click="
                                                        objModalEstadoVenta = {
                                                            idventa: item.idventa,
                                                            idestado_control_de_venta:
                                                                estadoControlDeVenta.CANCELADA,
                                                            titulo: 'Canceladas',
                                                            openModal: true,
                                                        }
                                                    "
                                                >
                                                    <v-list-item-title>
                                                        <v-icon>mdi-autorenew</v-icon>
                                                        Ventas Canceladas
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <template
                                                    v-if="
                                                        $moment(item.fecha_registro).isSameOrAfter('2024-03-01')
                                                    "
                                                >
                                                    <template v-if="item.nubefact_comprobante_emitido_result">
                                                        <v-list-item
                                                            v-if="
                                                                !item.nubefact_comprobante_anulado_result &&
                                                                validarPermiso('ventas.anularSunat') &&
                                                                $moment().isBefore(
                                                                    $moment(
                                                                        item.nubefact_comprobante_emitido_created_at
                                                                    ).add(3, 'days')
                                                                )
                                                            "
                                                            @click="
                                                                objModalAnularSunat = {
                                                                    idventa: item.idventa,
                                                                    openModal: true,
                                                                }
                                                            "
                                                        >
                                                            <v-list-item-title>
                                                                <v-icon>mdi-cancel</v-icon>
                                                                Anular comprobante
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item
                                                            :href="
                                                                item.nubefact_comprobante_emitido_result
                                                                    .enlace_del_pdf
                                                            "
                                                            target="_blank"
                                                        >
                                                            <v-list-item-title>
                                                                <v-icon>mdi-file-pdf</v-icon>
                                                                Ver comprobante (PDF)
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                    </template>

                                                    <template v-else>
                                                        <v-list-item
                                                            @click="
                                                                objModalEmitirSunat = {
                                                                    idventa: item.idventa,
                                                                    created_at: item.fecha_registro,
                                                                    openModal: true,
                                                                }
                                                            "
                                                            v-show="validarPermiso('ventas.enviarSunat')"
                                                        >
                                                            <v-list-item-title>
                                                                <v-icon>mdi-send</v-icon>
                                                                Enviar a SUNAT
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item
                                                            @click="
                                                                objModalEditarEmitirSunat = {
                                                                    idventa: item.idventa,
                                                                    created_at: item.fecha_registro,
                                                                    openModal: true,
                                                                }
                                                            "
                                                            v-show="validarPermiso('ventas.enviarSunat')"
                                                        >
                                                            <v-list-item-title>
                                                                <v-icon>mdi-pencil</v-icon>
                                                                Editar y Enviar a SUNAT
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                    </template>
                                                </template>
                                            </v-list>
                                        </v-menu>
                                    </template>

                                    <template v-slot:item.sunat="{ item }">
                                        <div class="d-flex align-center">
                                            <template v-if="$moment(item.fecha_registro).isBefore('2024-03-01')">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip color="green" small v-bind="attrs" v-on="on">
                                                            E
                                                        </v-chip>
                                                    </template>
                                                    <span>ENVIADO</span>
                                                </v-tooltip>
                                            </template>
                                            <template v-else-if="item.nubefact_comprobante_emitido_result">
                                                <v-tooltip bottom v-if="item.nubefact_comprobante_anulado_result">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip color="red" small v-bind="attrs" v-on="on">A</v-chip>
                                                    </template>
                                                    <span>ANULADO</span>
                                                </v-tooltip>
                                                <v-tooltip bottom v-else>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip color="green" small v-bind="attrs" v-on="on">
                                                            E
                                                        </v-chip>
                                                    </template>
                                                    <span>ENVIADO</span>
                                                </v-tooltip>
                                            </template>
                                            <template v-else>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip color="secondary" small v-bind="attrs" v-on="on">
                                                            P
                                                        </v-chip>
                                                    </template>
                                                    <span>PENDIENTE</span>
                                                </v-tooltip>
                                            </template>

                                            <v-tooltip bottom v-if="item.nubefact_comprobante_emitido_nro_comprobante">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon small class="ml-1" v-bind="attrs" v-on="on">
                                                        mdi-magnify
                                                    </v-icon>
                                                </template>
                                                <span>N° {{ item.nubefact_comprobante_emitido_nro_comprobante }}</span>
                                            </v-tooltip>
                                        </div>
                                    </template>

                                    <template v-slot:item.fecha_registro="{ item }">
                                        <span
                                            v-if="item.fecha_registro != null"
                                            v-text="$moment(item.fecha_registro).format('DD/MM/YYYY')"
                                        ></span>
                                    </template>

                                    <template v-slot:item.hora_registro="{ item }">
                                        <span
                                            v-if="item.fecha_registro != null"
                                            v-text="$moment(item.fecha_registro).format('hh:mm A')"
                                        ></span>
                                    </template>

                                    <template v-slot:item.cliente_nombres="{ item }">
                                        <span
                                            class="wrap-nombre"
                                            v-text="item.cliente_nombres + ' ' + item.cliente_apellidos"
                                        ></span>
                                    </template>

                                    <template v-slot:item.cliente_correo="{ item }">
                                        <div class="d-flex align-center">
                                            <span v-text="item.cliente_correo"></span>
                                            <v-btn
                                                icon
                                                x-small
                                                class="ml-1"
                                                title="Copiar correo"
                                                @click="copiarTexto(item.cliente_correo)"
                                            >
                                                <v-icon x-small>mdi-content-copy</v-icon>
                                            </v-btn>
                                        </div>
                                    </template>

                                    <template v-slot:item.detalle_pedido="{ item }">
                                        <v-btn
                                            @click="
                                                objModaldetalle = {
                                                    idventa: item.idventa,
                                                    idcliente: item.cliente_idcliente,
                                                    openModal: true,
                                                }
                                            "
                                            color="info"
                                            icon
                                        >
                                            <v-icon>mdi-magnify</v-icon>
                                        </v-btn>
                                    </template>

                                    <template v-slot:item.imprimir="{ item }">
                                        <v-btn
                                            @click="
                                                objModalImpresion = {
                                                    idventa: item.idventa,
                                                    openModal: true,
                                                }
                                            "
                                            color="info"
                                            icon
                                        >
                                            <v-icon>mdi-magnify</v-icon>
                                        </v-btn>
                                    </template>

                                    <template v-slot:item.pago="{ item }">
                                        <v-menu offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn text small color="info" v-bind="attrs" v-on="on">
                                                    {{ item.estadoPago.nombre }}
                                                    <v-icon right small>mdi-menu-down</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list dense>
                                                <v-list-item
                                                    @click="
                                                        objModalDetallePago = {
                                                            idventa: item.idventa,
                                                            openModal: true,
                                                        }
                                                    "
                                                >
                                                    <v-list-item-icon>
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-title>Ver detalle de pago</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item
                                                    @click="
                                                        objModalEstadoPago = {
                                                            idventa: item.idventa,
                                                            idestado_pago: item.idestado_pago,
                                                            openModal: true,
                                                        }
                                                    "
                                                >
                                                    <v-list-item-icon>
                                                        <v-icon>mdi-autorenew</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-title>Cambiar estado</v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </template>

                                    <template v-slot:item.tipo_envio="{ item }">
                                        <v-chip
                                            small
                                            :color="
                                                item.precio_entrega_rapido != null &&
                                                item.precio_entrega_rapido != 0
                                                    ? 'orange'
                                                    : 'blue-grey lighten-4'
                                            "
                                            :text-color="
                                                item.precio_entrega_rapido != null &&
                                                item.precio_entrega_rapido != 0
                                                    ? 'white'
                                                    : 'black'
                                            "
                                        >
                                            {{
                                                item.precio_entrega_rapido != null &&
                                                item.precio_entrega_rapido != 0
                                                    ? 'PROGRAMADO'
                                                    : 'REGULAR'
                                            }}
                                        </v-chip>
                                    </template>

                                    <template v-slot:item.direccion="{ item }">
                                        <v-btn
                                            @click="
                                                objModalDireccion = {
                                                    idventa: item.idventa,
                                                    openModal: true,
                                                }
                                            "
                                            color="info"
                                            icon
                                        >
                                            <v-icon>mdi-magnify</v-icon>
                                        </v-btn>
                                    </template>

                                    <template v-slot:item.ruc_razon_social="{ item }">
                                        <span v-if="item.facturacion_ruc">
                                            RUC: {{ item.facturacion_ruc }} | {{ item.facturacion_razonsocial }}
                                        </span>
                                    </template>
                                </v-data-table>

                                <p class="mb-0">
                                    Mostrando del registro
                                    <span v-text="primerRegistro"></span>
                                    al
                                    <span v-text="ultimoRegistro"></span>
                                    de un total de
                                    <span v-text="totalRegistro"></span>
                                    filas
                                </p>
                                <p class="text-caption grey--text">
                                    La selección se reinicia al cambiar de página o de filtros.
                                </p>
                            </v-col>

                            <v-col cols="12 text-center" v-show="loaderListado">
                                <v-progress-circular
                                    indeterminate
                                    color="primary"
                                    :size="100"
                                    :width="7"
                                ></v-progress-circular>
                            </v-col>

                            <v-col cols="12" v-show="arrRegistrosTabla.length > 0">
                                <v-pagination
                                    circle
                                    v-model="paginaActual"
                                    :length="cantidadprobadorVirtuales"
                                    :total-visible="7"
                                    @input="listarRegistros()"
                                    :disabled="loaderListado"
                                ></v-pagination>
                            </v-col>

                            <v-col cols="12" v-show="alertRegistroNoEcontrado">
                                <v-alert type="error" dense outlined class="text-center">
                                    NO HAY REGISTROS DISPONIBLES PARA MOSTRAR
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import modalDetalle from './Detalle';
    import modalImpresion from './Impresion';
    import modalDetallePago from './DetallePago';
    import modalEstadoPago from './EstadoPago';
    import modalEstadoVenta from './EstadoVenta';
    import modalDireccion from './Direccion';
    import modalEmitirSunat from './EmitirSunat';
    import modalAnularSunat from './AnularSunat';
    import modalEditarEmitirSunat from './EditarEmitirSunat';
    import modalEmitirSunatMasivo from './EmitirSunatMasivo';

    const ESTADOS_CONTROL_VENTA = Object.freeze({
        ENTRANTE: 1,
        FINALIZADA: 2,
        CANCELADA: 3,
        PROCESADA: 4,
        POR_ENVIAR: 5,
        ENVIADA: 6,
    });

    export default {
        components: {
            modalDetalle,
            modalImpresion,
            modalDetallePago,
            modalEstadoPago,
            modalEstadoVenta,
            modalDireccion,
            modalEmitirSunat,
            modalAnularSunat,
            modalEditarEmitirSunat,
            modalEmitirSunatMasivo,
        },
        data() {
            return {
                selected: [],
                objModalEmitirSunatMasivo: null,
                arrCantidadRegistros: [
                    {
                        texto: 10,
                        valor: 10,
                    },
                    {
                        texto: 30,
                        valor: 30,
                    },
                    {
                        texto: 50,
                        valor: 50,
                    },
                    {
                        texto: 100,
                        valor: 100,
                    },
                    {
                        texto: 500,
                        valor: 500,
                    },
                ],
                headers: [
                    { text: 'GESTIONAR', value: 'gestionar', sortable: false, align: 'center' },
                    { text: 'SUNAT', value: 'sunat', sortable: false },
                    { text: 'COD. VENTA', value: 'codigo_venta', sortable: false },
                    { text: 'COD. CLIENTE', value: 'cliente.codigo_cliente', sortable: false },
                    { text: 'FEC. REGISTRO', value: 'fecha_registro', sortable: false },
                    { text: 'HORA REG.', value: 'hora_registro', sortable: false },
                    { text: 'NOMBRE Y APELLIDO', value: 'cliente_nombres', sortable: false },
                    { text: 'CORREO', value: 'cliente_correo', sortable: false },
                    { text: 'N° PEDIDO', value: 'numero_pedido_cliente', sortable: false, align: 'center' },
                    { text: 'CUPÓN', value: 'cupon.nombre', sortable: false },
                    { text: 'DETALLE PEDIDO', value: 'detalle_pedido', sortable: false, align: 'center' },
                    { text: 'IMPRIMIR', value: 'imprimir', sortable: false, align: 'center' },
                    { text: 'MONTO', value: 'total_final', sortable: false },
                    { text: 'PAGO', value: 'pago', sortable: false },
                    { text: 'TIPO DE ENVÍO', value: 'tipo_envio', sortable: false, align: 'center' },
                    { text: 'EDITAR DIRECCIÓN', value: 'direccion', sortable: false, align: 'center' },
                    { text: 'BOLETA O FACTURA', value: 'comprobante.nombre', sortable: false },
                    { text: 'RUC / RAZÓN SOCIAL', value: 'ruc_razon_social', sortable: false },
                ],
                loaderListado: false,
                alertRegistroNoEcontrado: false,
                cmbCantidadRegistros: 10,
                arrRegistrosTabla: [],
                cmbEstadoPago: [],
                cmbMetodoPago: [],
                cmbTipoDireccion: [],
                paginaActual: 1,
                cantidadprobadorVirtuales: 1,
                primerRegistro: 0,
                ultimoRegistro: 0,
                totalRegistro: 0,
                iptBuscarRegisro: '',
                filtroFechaDesde: '',
                filtroFechaHasta: '',
                filtroEstadoPago: '',
                filtroMetodoPago: '',
                objModaldetalle: null,
                objModalImpresion: null,
                objModalDetallePago: null,
                objModalEstadoPago: null,
                objModalEstadoVenta: null,
                objModalDireccion: null,
                objModalEmitirSunat: null,
                objModalAnularSunat: null,
                btnReporteExcel: false,
                objModalEditarEmitirSunat: null,
            };
        },

        methods: {
            formatFecha(fecha) {
                return fecha ? this.$moment(fecha).format('DD/MM/YYYY') : '';
            },

            rowClass(item) {
                return item.precio_entrega_rapido != null && item.precio_entrega_rapido != 0
                    ? 'pintar-grilla'
                    : '';
            },

            copiarTexto(texto) {
                if (!texto) return;
                navigator.clipboard
                    .writeText(texto)
                    .then(() => {
                        this.$toasted.success('Copiado al portapapeles', {
                            icon: 'mdi-check',
                        });
                    })
                    .catch(() => {
                        this.$toasted.error('No se pudo copiar', {
                            icon: 'mdi-close',
                        });
                    });
            },

            listarRegistros() {
                this.arrRegistrosTabla = [];
                this.selected = [];
                this.loaderListado = true;
                this.alertRegistroNoEcontrado = false;
                this.axios({
                    method: 'GET',
                    url: 'api/panel/ventas/v2',
                    params: {
                        cantidadRegistros: this.cmbCantidadRegistros,
                        paginaActual: this.paginaActual,
                        filtroFechaDesde: this.filtroFechaDesde,
                        filtroFechaHasta: this.filtroFechaHasta,
                        filtroEstadoPago: this.filtroEstadoPago,
                        filtroMetodoPago: this.filtroMetodoPago,
                        idestado_control_de_venta: ESTADOS_CONTROL_VENTA.PROCESADA,
                    },
                })
                    .then((response) => {
                        let listado = response.data.data;

                        this.arrRegistrosTabla = listado.data;
                        this.paginaActual = listado.current_page;
                        this.cantidadprobadorVirtuales = listado.last_page;
                        this.primerRegistro = listado.from;
                        this.ultimoRegistro = listado.to;
                        this.totalRegistro = listado.total;

                        if (this.arrRegistrosTabla.length === 0) {
                            this.alertRegistroNoEcontrado = true;
                        } else {
                            this.alertRegistroNoEcontrado = false;
                        }
                    })
                    .catch((error) => {
                        console.log(error.response);
                    })
                    .then(() => {
                        this.loaderListado = false;
                        this.$vuetify.goTo(this.$refs.tblListado);
                    });
            },

            getFiltros() {
                this.axios({
                    method: 'POST',
                    url: 'api/panel/ventas/v2/filtros',
                })
                    .then((response) => {
                        let status = response.status;
                        if (status === 200) {
                            this.cmbEstadoPago = response.data.data.estadoPago;
                            this.cmbMetodoPago = response.data.data.metodoPago;
                            this.cmbTipoDireccion = response.data.data.tipoDireccion;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },

            reporteExcel() {
                const querys = new URLSearchParams({
                    filtroFechaDesde: this.filtroFechaDesde,
                    filtroFechaHasta: this.filtroFechaHasta,
                    filtroEstadoPago: this.filtroEstadoPago,
                    filtroMetodoPago: this.filtroMetodoPago,
                    idestado_control_de_venta: ESTADOS_CONTROL_VENTA.PROCESADA,
                });

                window.open(this.apiUrl('api/panel/ventas/v2/reporteExcel?' + querys.toString()), '_self');
            },

            filtrar() {
                this.paginaActual = 1;
                this.listarRegistros();
            },

            imprimirSeleccionados() {
                if (this.selected.length === 0) {
                    this.$toasted.error('Selecciona al menos una venta para imprimir.', {
                        icon: 'mdi-close',
                    });
                    return;
                }

                if (this.selected.length > 100) {
                    this.$toasted.error('Selecciona como máximo 100 ventas para imprimir.', {
                        icon: 'mdi-close',
                    });
                    return;
                }

                const params = this.selected
                    .map((item) => 'idventa[]=' + encodeURIComponent(item.idventa))
                    .join('&');

                window.open(this.apiUrl('api/panel/ventas/v2/impresionDetalleMasivo?' + params), '_blank');
            },

            enviarSunatSeleccionados() {
                if (this.selected.length === 0) {
                    this.$toasted.error('Selecciona al menos una venta para enviar a SUNAT.', {
                        icon: 'mdi-close',
                    });
                    return;
                }

                if (this.selected.length > 50) {
                    this.$toasted.error('Selecciona como máximo 50 ventas para enviar a SUNAT.', {
                        icon: 'mdi-close',
                    });
                    return;
                }

                this.objModalEmitirSunatMasivo = {
                    items: this.selected,
                    openModal: true,
                };
            },

            limpiarFiltros() {
                this.cmbCantidadRegistros = 10;
                this.filtroFechaDesde = '';
                this.filtroFechaHasta = '';
                this.filtroEstadoPago = '';
                this.filtroMetodoPago = '';
                this.listarRegistros();
            },
        },

        computed: {
            estadoControlDeVenta() {
                return ESTADOS_CONTROL_VENTA;
            },
        },

        created() {
            if (!this.validarPermiso('ventas.listado')) {
                this.$toasted.error('Usted no tiene permisos para esta sección', {
                    icon: 'mdi-close',
                });

                this.$router.push({
                    name: 'inicioPanel',
                });
            }
            this.listarRegistros();
            this.getFiltros();
        },
    };
</script>
<style scoped>
    ::v-deep .pintar-grilla {
        background-color: rgb(230, 128, 128) !important;
    }
    ::v-deep .v-data-table__wrapper tbody tr:nth-of-type(even) {
        background-color: rgba(0, 0, 0, 0.04);
    }
    ::v-deep .v-data-table__wrapper table tbody tr td {
        height: auto;
        padding-top: 8px;
        padding-bottom: 8px;
        vertical-align: middle;
    }
    .wrap-nombre {
        display: inline-block;
        max-width: 160px;
        white-space: normal;
        word-break: break-word;
        line-height: 1.2;
    }
</style>
